import { Api_url } from '../../common/api_url'
import { API_XANO_SEARCH_BASE_URL, API_XANO_SEARCH_DROPDOWN_BASE_URL } from '../../config/api_config'
import { axiosNoAuth } from '../../config/axiosInstances'
import { SET_SEARCH_RESULTS } from './types';

export function getSearchResults(searchString, userId, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const url = userId === undefined ? API_XANO_SEARCH_BASE_URL + Api_url.GetSearchResults + searchString : API_XANO_SEARCH_BASE_URL + Api_url.GetSearchResults + searchString + '&user_id=' + userId;
            const response = await axiosNoAuth.get(url);
            dispatch({
                type: SET_SEARCH_RESULTS,
                payload: { searchString: searchString, ...response.data }
            });
            successCallback && successCallback(response.data)
        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}

export function getSearchResultsForDropdown(searchString, successCallback, errorCallback) {
    return async function (dispatch) {
        try {
            const response = await axiosNoAuth.get(API_XANO_SEARCH_DROPDOWN_BASE_URL + Api_url.GetSearchResultsDropDown + encodeURIComponent(searchString));
            successCallback && successCallback(response.data)
        } catch (err) {
            console.log(err)
            errorCallback && errorCallback(err)
        }
    }
}